import type { ReactNode } from "react";
import { isProduction } from "../api/mode.ts";
import { IconCheck } from "../components/Icons.tsx";
import { LanguagePicker } from "../components/LanguagePicker.tsx";
import { rich, useT } from "../i18n/index.tsx";
import { logo, mascotPresenting } from "../assets/images.ts";

/** "<b>…</b>" in an auth panel title → the accent-coloured part. */
export const panelAccent = { b: (c: string) => <span className="panel-accent">{c}</span> };

/** Split layout for login / invite: form on the left, brand panel with the mascot on the right. */
export function AuthLayout({ children, panelTitle, panelPoints }: { children: ReactNode; panelTitle?: ReactNode; panelPoints?: string[] }) {
  const t = useT();
  return (
    <div className="auth">
      <div className="auth-main">
        <header className="auth-head">
          <a href="https://icryptonow.com/" aria-label={t.auth.homeLabel}>
            <img src={logo} alt="iCryptoNow" width={176} height={30} />
          </a>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {!isProduction && <span className="env-badge">{t.shell.testnet}</span>}
            <LanguagePicker />
          </div>
        </header>
        <main className="auth-body">{children}</main>
        <footer className="auth-foot">
          <span>© {new Date().getFullYear()} iCryptoNow</span>
          <a href="https://icryptonow.com/security/" target="_blank" rel="noreferrer noopener">{t.auth.security}</a>
          <a href="https://icryptonow.com/contact/" target="_blank" rel="noreferrer noopener">{t.auth.support}</a>
        </footer>
      </div>
      <aside className="auth-panel" aria-hidden="true">
        <div className="auth-panel-inner">
          <div className="eyebrow">{t.auth.merchantConsole}</div>
          <h2>{panelTitle ?? rich(t.auth.panelTitle, panelAccent)}</h2>
          <ul className="auth-points">
            {(panelPoints ?? t.auth.panelPoints).map((p) => (
              <li key={p}><IconCheck size={18} /> {p}</li>
            ))}
          </ul>
          <div className="auth-scene">
            <span className="auth-orbit" />
            <img src={mascotPresenting} fetchPriority="high" alt="" width={420} height={448} className="auth-mascot" />
          </div>
        </div>
      </aside>
    </div>
  );
}
